"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledProgressWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  border-radius: 0.5rem;\n  background: ", ";\n"])), function (p) {
  return p.widthWrapper || "8rem";
}, function (p) {
  return process.env.REACT_APP_COLOR_BETBAR_PROGRESS_BACKGROUND || p.theme.colorLightGrey;
});

var StyledProgressBar = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", ";\n  border-radius: inherit;\n  background: ", ";\n  transition: width 0.45s;\n"])), function (p) {
  return p.heightBar || "0.25rem";
}, function (p) {
  return process.env.REACT_APP_COLOR_BETBAR_PROGRESS_ACCENT || p.theme.colorPrimary;
});

var Wrapper = function Wrapper(_ref) {
  var widthWrapper = _ref.widthWrapper,
      heightBar = _ref.heightBar,
      total = _ref.total,
      current = _ref.current;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledProgressWrapper, {
    widthWrapper: widthWrapper,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledProgressBar, {
      heightBar: heightBar,
      style: {
        width: "".concat(!current ? 5 : current / total * 100, "%")
      }
    })
  });
};

var _default = Wrapper;
exports.default = _default;